<input
  class="input"
  [class.error]="error"
  placeholder="00:00:00:00"
  [ngModel]="inputValue"
  (ngModelChange)="updateInputValue($event)"
  (blur)="blueInputValue()"
  (keydown.enter)="blueInputValue()"
/>
